import {
  VermarkterVollmachtUploadSuccessDocument_completeStatus,
  VermarkterVollmachtUploadSuccessSignature_resultStatus
} from "../../../../../../types/api.types";

export const SIGNATURE_STATUS_LABELS: Record<
  VermarkterVollmachtUploadSuccessSignature_resultStatus,
  string
> = {
  [VermarkterVollmachtUploadSuccessSignature_resultStatus.signed]:
    "Signatur erkannt",
  [VermarkterVollmachtUploadSuccessSignature_resultStatus.unsigned]:
    "Keine Signatur erkannt",
  [VermarkterVollmachtUploadSuccessSignature_resultStatus.detection_failed]:
    "Erkennung fehlgeschlagen"
};

export const DOCUMENT_STATUS_LABELS: Record<
  VermarkterVollmachtUploadSuccessDocument_completeStatus,
  string
> = {
  [VermarkterVollmachtUploadSuccessDocument_completeStatus.sufficient]:
    "Dokument vollständig",
  [VermarkterVollmachtUploadSuccessDocument_completeStatus.insufficient]:
    "Dokument unvollständig",
  [VermarkterVollmachtUploadSuccessDocument_completeStatus.detection_failed]:
    "Erkennung fehlgeschlagen"
};

export const COMPANY_FIELDS: Array<{
  key: keyof {
    name: string;
    street_and_nr: string;
    postal_code_city: string;
    abr_number: string;
  };
  label: string;
  errorCode: string;
}> = [
  {
    key: "name",
    label: "Name",
    errorCode: "company_name_not_found"
  },
  {
    key: "street_and_nr",
    label: "Straße",
    errorCode: "company_street_and_nr_not_found"
  },
  {
    key: "postal_code_city",
    label: "PLZ / Ort",
    errorCode: "company_postal_code_city_not_found"
  },
  {
    key: "abr_number",
    label: "ABR-Nummer",
    errorCode: "company_abr_number_not_found"
  }
];

export const GENERATOR_FIELDS: Array<{
  key: keyof { tr_id: string; see_number: string };
  label: string;
  errorCode: string;
}> = [
  {
    key: "tr_id",
    label: "TR-ID",
    errorCode: "generator_tr_id_not_found"
  }
];

export const STATUS_FIELDS = [
  {
    label: "Signatur",
    statusKey: "signature_result" as const,
    labelMap: SIGNATURE_STATUS_LABELS
  },
  {
    label: "Vollständigkeit",
    statusKey: "document_complete" as const,
    labelMap: DOCUMENT_STATUS_LABELS
  }
] as const;

export const STATUS_BADGE_BASE_COLORS: Record<string, "green" | "warning"> = {
  signed: "green",
  sufficient: "green",
  unsigned: "warning",
  insufficient: "warning",
  detection_failed: "warning"
};

export const ADDITIONAL_ERROR_LABELS: Record<string, string> = {
  unexpected_see_number_found: "Unerwartete SEE-Nummer(n) gefunden",
  unexpected_tr_id_found: "Unerwartete TR-ID(s) gefunden"
};
